// components/agent/employees/AgentGridEmployees.jsx
"use client";

import AgentProfileCardForAgent from "./AgentProfileCardForAgent";

export default function AgentGridEmployees({ agents }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3">
      {agents.map((agent, index) => (
        <AgentProfileCardForAgent key={index} agent={agent} />
      ))}
    </div>
  );
}